import {parallel, sequence} from '@gongxigames/framework/slotV2/fsm/acts/ActFactory';
import {IdleUIAct} from '@gongxigames/framework/slotV2/ui/acts/IdleUIAct';
import {InitSettingsUIAct} from '@gongxigames/framework/slotV2/ui/acts/InitSettingsUIAct';
import {UIState} from '@gongxigames/framework/slotV2/baseClasses/uiState/UIState';

export class InitSettingsUIState extends UIState {
    public static readonly ID = 'InitSettingsUIState';

    public setAct(): void {
        this.act = sequence([
            InitSettingsUIAct
        ]);
    }
}